import React, { useRef, useState, useEffect } from "react";

export default function SignaturePad() {
  const canvasRef = useRef(null);
  const ctxRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  
  const goToHomePage = () => {
     window.location.href = '/'; 
    // Or navigate('/home'); if your home page path is explicitly '/home'
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    const ctx = canvas.getContext("2d");
    ctx.lineCap = "round";
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 2;
    ctxRef.current = ctx;
  }, []);

  const startDrawing = (e) => {
    ctxRef.current.beginPath();
    ctxRef.current.moveTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    setIsDrawing(true);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    ctxRef.current.lineTo(e.nativeEvent.offsetX, e.nativeEvent.offsetY);
    ctxRef.current.stroke();
  };

  const stopDrawing = () => {
    ctxRef.current.closePath();
    setIsDrawing(false);
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    ctxRef.current.clearRect(0, 0, canvas.width, canvas.height);
  };

  const saveSignature = () => {
    const canvas = canvasRef.current;
    const dataURL = canvas.toDataURL("image/png");
    const link = document.createElement("a");
  //  link.download = "signature.png";
  //  link.href = dataURL;
  //  link.click();
     window.location.href = '/'; 
  };

   

  return (
    <div style={styles.container}>
      <div style={styles.header}>Digital Signature Capture</div>

      <div style={{ marginBottom: "8px", fontWeight: "600", fontSize: "18px" }}>
        Sign within the box
      </div>

      <div style={styles.canvasWrapper}>
        <canvas
          ref={canvasRef}
          style={styles.canvas}
          onMouseDown={startDrawing}
          onMouseMove={draw}
          onMouseUp={stopDrawing}
          onMouseLeave={stopDrawing}
        />
      </div>

      <div style={styles.buttonRow}>
        <button style={styles.clearBtn} onClick={clearCanvas}>
          ❌ Clear Signature
        </button>
        <button style={styles.saveBtn} onClick={saveSignature}>
          💾 Save Signature
        </button>
       
      </div>
    </div>
  );
}

const styles = {
  container: {
    width: "80%",
    margin: "20px auto",
    background: "#fff",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
  header: {
    background: "linear-gradient(to right, #4776E6, #8E54E9)",
    color: "#fff",
    padding: "15px",
    borderRadius: "8px",
    textAlign: "center",
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "20px",
  },
  canvasWrapper: {
    border: "2px solid #ddd",
    borderRadius: "8px",
    height: "250px",
    marginBottom: "20px",
  },
  canvas: {
    width: "100%",
    height: "100%",
  },
  buttonRow: {
    display: "flex",
    gap: "15px",
  },
  clearBtn: {
    background: "#e74c3c",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "6px",
    fontSize: "16px",
    cursor: "pointer",
  },
  saveBtn: {
    background: "#4267f5",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "6px",
    fontSize: "16px",
    cursor: "pointer",
  },
};
